
import * as _ from 'lodash';
import ExchangeService from '../services/exchange.service';

const initialState = {
}

export const exchange = {
  namespaced: true,
  state: initialState,
  actions: {
    async loadRates({ commit,dispatch }, payload) {
      let exchangeResponse = await ExchangeService.getRates();
      if(exchangeResponse && exchangeResponse.data){
        commit('loadRatesSuccess', exchangeResponse.data)
      }
    },
  },
  getters: {
    rates: state => state,
  },
  mutations: {
    loadRatesSuccess(state, exchanges) {
      _.forEach(exchanges,(e) => {
        state[`${e.code}`] = e.rate;
      })
    },
  },
};

export default exchange;



// WEBPACK FOOTER //
// ./src/store/exchange.module.js